import {Nullable, OfferCommonFields} from 'common/types';
import {
  CommonAction,
  FETCH_OFFER_OPTIONS_FAILURE,
  FETCH_OFFER_OPTIONS_REQUEST,
  FETCH_OFFER_OPTIONS_SUCCESS,
} from '../types';

interface State {
  data: Nullable<OfferCommonFields>;
  loadedKey: Nullable<string>;
  requestedKey: Nullable<string>;
  isFetching: boolean;
  error: Nullable<Error>;
}

const initialState: State = {
  data: null,
  loadedKey: null,
  requestedKey: null,
  isFetching: false,
  error: null,
};

export const offerOptionsReducer = (
  state: State = initialState,
  action: CommonAction
) => {
  switch (action.type) {
    case FETCH_OFFER_OPTIONS_REQUEST:
      return {
        ...state,

        error: null,
        requestedKey: `${Number(action.payload.itemType)}:${Number(action.payload.operType)}:${Number(action.payload.sectionMode || 0)}`,
        data: null,
        loadedKey: null,
        isFetching: true,
      };

    case FETCH_OFFER_OPTIONS_SUCCESS:
      if (action.payload.requestKey !== state.requestedKey) return state;
      return {
        ...state,
        data: action.payload.offerOptions,
        loadedKey: action.payload.requestKey,
        isFetching: false,
      };

    case FETCH_OFFER_OPTIONS_FAILURE:
      return {
        ...state,
        data: null,
        loadedKey: null,
        isFetching: false,
        error: action.error,
      };

    default:
      return state;
  }
};
